const selectors = {
    scrollIndicator: '#scroll_indicator_button',
    navWrapper: '#navbar_wrapper'
};

const init = () => {
    const scrollIndicatorButtonElement = document.querySelector(selectors.scrollIndicator);
    const navbarWrapperHTMLElement = document.querySelector(selectors.navWrapper);
    if (!scrollIndicatorButtonElement) return;
    
    scrollIndicatorButtonElement.addEventListener('click', () => {
        window.scrollTo(0, window.innerHeight - (navbarWrapperHTMLElement.offsetHeight ?? null))
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;